module.exports = __webpack_public_path__ + "static/img/n16.7e54cd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/resourceShow/img/zh/n16.png
// module id = P8ZB
// module chunks = 3